module.exports = __webpack_public_path__ + "img/58200.b431e1a4.jpg";